/**
 * KAN-906: число активных фильтров таблицы CRM, спрятанных на телефоне в панель "Фильтры"
 * (значок на кнопке). Считается отклонение от вида по умолчанию: "Только новые лиды"
 * выключен (когда доступен), исход и сортировка не по умолчанию для периода, быстрый
 * фильтр, атрибут, город, организация, менеджер. Период и поиск видны в строке и не
 * считаются. При активном быстром фильтре его исход и сортировка входят в него
 * (не считаются второй раз).
 */
import type { CrmLocationFilterValue } from '@/components/crm/CrmLocationFilters';
import type { CrmRange } from '@/lib/crmTable';
import { MANAGER_FILTER_NONE } from '@/lib/crmLeadFilters';
import { parseCrmTableOutcome } from '@/lib/crmTablePeriod';
import { parseCrmTableSort } from '@/lib/crmTableSort';
import type { CrmTableShortcut } from '@/lib/crmTableShortcuts';
import type { CrmTableSort } from '@/types/crm';
import type { CrmTableOutcome } from '@/types/crmPipeline';

export interface CrmTableActiveFiltersInput {
  range: CrmRange | null;
  outcome: CrmTableOutcome;
  sort: CrmTableSort;
  shortcut: CrmTableShortcut | null;
  /** undefined - переключателя нет. */
  newLeads?: { newLeadsOnly: boolean; available: boolean };
  hasAttribute: boolean;
  location: CrmLocationFilterValue;
  manager: string | null;
}

export function crmTableActiveFilterCount(input: CrmTableActiveFiltersInput): number {
  const { range, outcome, sort, shortcut, newLeads, hasAttribute, location, manager } = input;
  let count = 0;
  if (newLeads?.available && !newLeads.newLeadsOnly) count += 1;
  if (shortcut) {
    count += 1;
  } else {
    if (outcome !== parseCrmTableOutcome(null, range)) count += 1;
    if (sort !== parseCrmTableSort(null, range)) count += 1;
  }
  if (hasAttribute) count += 1;
  if (location.city) count += 1;
  if (location.companyId || location.company) count += 1;
  // manager=none ставит сам "Неразобранные".
  if (manager && !(shortcut === 'unassigned' && manager === MANAGER_FILTER_NONE)) count += 1;
  return count;
}
